import type { UploadProps } from 'antd';

export const IMAGE_TYPES = '.jpg,.JPG,.jpeg,.JPEG,.png,.PNG';

export const DEFAULT_PROPS = {
  action: '/v4/supertext-java/files/upload',
  accept:
    '.pdf,.PDF,.doc,.DOCX,.doc,.DOC,.wps,.WPS,.zip,.ZIP,.txt,.TXT' +
    IMAGE_TYPES,
  multiple: true,
  showUploadList: false,
} as UploadProps;

export const UNIT_MB = 1024 * 1024;
export const SIZE_2MB = 2 * UNIT_MB;
export const SIZE_20MB = 20 * UNIT_MB;
export const SIZE_100MB = 100 * UNIT_MB;
export const IMAGE_REG = /^image\/.+/;
export const APPLICATION_REG = /^application\/.+/;
export const TXT_REG = /^text\/plain$/;
export const ZIP_REG = /^application\/zip$/;
export const DOC_REG =
  /^application\/pdf|application\/msword|application\/vnd\.openxmlformats-officedocument\.wordprocessingml\.document|application\/wps-writer$/;

export const docTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/wps-writer',
] as const;

export const imageTypes = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'image/bmp',
] as const;

export const STATUS = [
  {
    value: 0,
    label: '任务创建',
  },
  {
    value: 1,
    label: '解析中',
  },
  {
    value: 2,
    label: '解析完成',
  },
  {
    value: 3,
    label: '解析失败',
  },
];

export const MARK_STATUS = [
  {
    value: 0,
    label: '未标注',
  },
  {
    value: 1,
    label: '待确认',
  },
  {
    value: 2,
    label: '已标注',
  },
  {
    value: 3,
    label: '无法标注',
  },
];
